import script from "./MantenimientoCajasView.vue?vue&type=script&setup=true&lang=js"
export * from "./MantenimientoCajasView.vue?vue&type=script&setup=true&lang=js"

import "./MantenimientoCajasView.vue?vue&type=style&index=0&id=d2572b18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2572b18"]])

export default __exports__